import React, { useEffect, useState } from "react";
import { Download, ExternalLink } from "lucide-react";
import { chargerPdf } from "./api";

/* Le PDF s'affiche dans la console : monté une seule fois, il écoute les demandes de
   lecture (« Relire », « Aperçu », « PDF »). L'ancien window.open() sur un blob partait
   après l'appel réseau, donc hors du clic : les navigateurs le bloquaient sans rien dire. */
export default function VisionneusePdf() {
  const [etat, setEtat] = useState(null);

  useEffect(() => {
    const ecouter = async (e) => {
      const { chemin, titre } = e.detail;
      setEtat({ chemin, titre, url: "", err: "" });
      try {
        setEtat({ chemin, titre, url: await chargerPdf(chemin), err: "" });
      } catch (err) {
        setEtat({ chemin, titre, url: "", err: err.message });
      }
    };
    window.addEventListener("console-pdf", ecouter);
    return () => window.removeEventListener("console-pdf", ecouter);
  }, []);

  useEffect(() => () => { if (etat?.url) URL.revokeObjectURL(etat.url); }, [etat?.url]);

  // Échap ferme la visionneuse, comme partout ailleurs.
  useEffect(() => {
    if (!etat) return undefined;
    const touche = (e) => { if (e.key === "Escape") setEtat(null); };
    window.addEventListener("keydown", touche);
    return () => window.removeEventListener("keydown", touche);
  }, [etat]);

  if (!etat) return null;
  const nom = `${(etat.chemin.split("/").pop() || "document").replace(/[^\w.-]/g, "")}.pdf`;

  return (
    <div className="fixed inset-0 z-[60] flex flex-col" style={{ background: "rgba(15,27,45,0.75)" }}
      data-testid="visionneuse-pdf">
      {/* Sur téléphone, le titre et les boutons poussaient le ✕ hors de l'écran : il reste
          maintenant sur la première ligne, les boutons passent dessous si besoin. */}
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2 px-4 py-3 text-white"
        style={{ paddingTop: "calc(0.75rem + env(safe-area-inset-top, 0px))" }}>
        <div className="font-display text-base min-w-0 flex-1 truncate">{etat.titre || "Document"}</div>
        <button className="shrink-0 order-2 sm:order-3 text-2xl leading-none px-1" onClick={() => setEtat(null)}
          aria-label="Fermer" data-testid="pdf-fermer">✕</button>
        {etat.url && (
          <div className="order-3 sm:order-2 flex flex-wrap gap-2 w-full sm:w-auto">
            <a className="btn-ghost" style={{ background: "#fff" }} href={etat.url} download={nom}
              data-testid="pdf-telecharger"><Download size={13} /> Télécharger</a>
            <a className="btn-ghost" style={{ background: "#fff" }} href={etat.url} target="_blank"
              rel="noreferrer" data-testid="pdf-nouvel-onglet"><ExternalLink size={13} /> Nouvel onglet</a>
          </div>
        )}
      </div>
      <div className="flex-1 bg-white mx-3 mb-3 rounded-2xl overflow-hidden flex items-center justify-center">
        {etat.err ? (
          <div className="text-center px-6" data-testid="pdf-erreur">
            <p className="text-sm font-semibold" style={{ color: "#B91C1C" }}>Ce document n'a pas pu être lu.</p>
            <p className="text-sm text-[var(--muted)] mt-2">{etat.err}</p>
          </div>
        ) : etat.url ? (
          <iframe title="PDF" src={etat.url} className="w-full h-full" data-testid="pdf-cadre" />
        ) : (
          <p className="text-sm text-[var(--muted)]">Ouverture du document…</p>
        )}
      </div>
    </div>
  );
}
